import { background } from "@chakra-ui/react";

export default {
    baseStyle: {
        container: {
            spacing: 0
        },
        heading: {
            textStyle: 'webH2',
            mt: {base: 6, lg: 0},
            mb: {base: 12, lg: 16}
        },
        sectionHeading: {
            textStyle: 'webH4',
            mb: 0
        },
        contactRow: {
            justify: 'space-between',
            align: 'center'
        },
        contactSection: {
            flexDirection: 'column',
            gap: 3,
            mb: {base: 12, lg: 16}
        },
        titleSection: {
            mb: 3
        },
        apartmentToggle: {
            align: 'center',
            gap: 2,
            cursor: 'pointer'
        },
        apartmentToggleText: {
             textStyle: 'labelXs'
        },
        signInButton: {
            textStyle: 'bodyXsLink',
            display: 'block',
            minH: 'auto',
            h: 'auto'
        },
        formStack: {
            spacing: 3
        },
        fieldRow: {
            columns: 1,
            gap: 3
        },
        fieldRowHalf: {
            columns: 2,
            gap: 3
        },
        suggestionList: {
            spacing: 0,
            position: 'absolute',
            left: 0,
            right: 0,
            top: '49px',
            bg: 'white',
            border: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            zIndex: 20,
            maxH: '240px',
            overflowY: 'auto',
            boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.1)',
            sx: {
                '&::-webkit-scrollbar': {width: '5px'},
                '&::-webkit-scrollbar-button': {display: 'none'},
                '&::-webkit-scrollbar-thumb': {
                    bg: 'webTheme.strokeSecondary',
                    borderRadius: 'full'
                },
                '&::-webkit-scrollbar-track': {
                    bg: 'transparent',
                    borderRadius: 'full'
                }
            }
        },
        suggestionItem: {
            textStyle: 'bodySmRegular',
            px: 2,
            py: 3,
            minH: '48px',
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            _last: {borderBottom: 0},
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            wordBreak: 'break-word',
            _hover: {bg: 'webTheme.fieldHover'},
            _focus: {bg: 'webTheme.fieldHover', outline: 'none'}
        },
        suggestionItemGroup: {
            textStyle: 'bodySmRegular',
            px: '20px',
            py: '14px',
            minH: '48px',
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            _last: {borderBottom: 0},
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            wordBreak: 'break-word',
            _hover: {bg: 'webTheme.fieldHover'},
            _focus: {bg: 'webTheme.fieldHover', outline: 'none'}
        },
        suggestionGroupHeader: {
            justifyContent: 'space-between',
            px: 2,
            py: 3,
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            _last: {borderBottom: '1px solid', borderColor: 'webTheme.strokeTertiary'}
        },
        suggestionGroupLabel: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textSecondary'
        },
        suggestionGroupAddress: {
            textStyle: 'bodySmRegular'
        },
        addressBookCta: {
            display: 'block',
            textStyle: 'bodyXsLink',
            minH: 'auto',
            h: 'auto'
        }
    }
}
